import { InjectionToken, Provider } from '@angular/core';

import { HelpCenterStore } from './help-center.store';

export const HELP_CENTER_API_URL = new InjectionToken<string>('HELP_CENTER_API_URL');
export const PUBLIC_CLOUD = new InjectionToken<boolean>('PUBLIC_CLOUD');

export function provideHelpCenterStore(apiUrl: string, publicCloud: boolean): Provider[] {
  return [
    HelpCenterStore,
    {
      provide: HELP_CENTER_API_URL,
      useValue: apiUrl,
    },
    {
      provide: PUBLIC_CLOUD,
      useValue: publicCloud,
    },
  ];
}
